import { render } from "./LogoText.vue?vue&type=template&id=750e09a0"
const script = {}

import "./LogoText.vue?vue&type=style&index=0&id=750e09a0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__